import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Post } from '../../lib/supabase';
import '../../styles/components/posts-card.css';

interface PostsCardProps {
  posts: Post[];
  loading?: boolean;
  error?: string | null;
  className?: string;
}

const PostsCard: React.FC<PostsCardProps> = ({ posts, loading, error, className = '' }) => {
  const navigate = useNavigate();

  // Get the last 5 posts (most recent)
  const displayPosts = posts.slice(0, 5);

  const handlePostClick = (post: Post) => {
    if (post.route) {
      navigate(post.route);
    }
  };

  const handleSeeAllClick = () => {
    navigate('/posts');
  };

  return (
    <div className={`posts-card ${className}`}>
      <div className="card-content">
        <div className="posts-card-header">
          <h3 className="card-title">Recent Posts</h3>
          {!loading && posts.length > 5 && (
            <button onClick={handleSeeAllClick} className="see-all-button text-hover-yellow">
              All Posts
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                <path
                  d="M6 4L10 8L6 12"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </button>
          )}
        </div>
        <p className="card-description">Our latest news, stories and updates.</p>

        {loading && (
          <div className="posts-list">
            <p className="posts-loading-text">Loading posts...</p>
          </div>
        )}

        {error && !loading && posts.length === 0 && (
          <div className="posts-list">
            <p className="posts-loading-text">Unable to load posts</p>
          </div>
        )}

        {!loading && displayPosts.length > 0 && (
          <div className="posts-list">
            {displayPosts.map((post) => (
              <div
                key={post.id}
                className={`post-list-item ${post.route ? 'clickable' : ''}`}
                onClick={() => handlePostClick(post)}
              >
                <div className="post-list-item-content">
                  <span className="post-title">{post.title}</span>
                  {post.route && (
                    <svg className="post-arrow" width="14" height="14" viewBox="0 0 16 16" fill="none">
                      <path
                        d="M6 4L10 8L6 12"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  )}
                </div>
                {post.category && (
                  <span className="post-category">{post.category}</span>
                )}
              </div>
            ))}
          </div>
        )}

      </div>
    </div>
  );
};

export default PostsCard;
